<template>
  <validation-observer
    ref="observer"
    v-slot="{ invalid }"
    tag="form"
  >
    <v-form>
      <app-widget
        actions
        class-widget="xs12"
      >
        <div slot="widget-content">
          <div v-if="industria.logotipo">
            <v-subheader
              class="font-weight-bold secondary--text"
              v-text="`Logotipo atual`"
            />
            <v-img
              v-if="image"
              class="white--text align-end"
              height="200px"
              contain
              :src="image"
            >
              <v-spacer />
            </v-img>
            <div class="align-center">
              <v-btn
                @click="removerLogo"
                text
                block
                class="grey--text"
                small
              >
                Excluir logotipo
              </v-btn>
            </div>
            <v-divider class="mt-4" />
          </div>
          <v-subheader
            class="font-weight-bold secondary--text mt-4"
            v-text="`Carregar novo logotipo`"
          />
          <validation-provider
            name="logotipo"
            rules="required|image|ext:jpg,png,jpeg"
            v-slot="{ errors }"
          >
            <v-file-input
              prepend-icon="cloud_upload"
              label="Selecionar um logotipo"
              v-model="file"
              show-size
              accept="image/png, image/jpeg, image/jpg"
              :error-messages="errors[0]"
            />
          </validation-provider>
        </div>
        <div slot="widget-actions">
          <app-button
            @click.native.prevent="carregarLogo"
            :disable="invalid"
          >
            Carregar
          </app-button>
        </div>
      </app-widget>
    </v-form>
  </validation-observer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import AppWidget from '@/components/AppWidget'
import AppButton from '@/components/AppButton'
export default {
  name: 'AppListaTelefone',
  components: {
    AppWidget,
    ValidationProvider,
    ValidationObserver,
    AppButton
  },
  data () {
    return {
      file: null,
      image: null
    }
  },
  computed: {
    ...mapGetters(['industria'])
  },
  created () {
    this.image = this.$options.filters.getLogotipoURI(this.industria.logotipo)
  },
  methods: {
    ...mapActions(['uploadLogotipo', 'removeLogotipo']),
    reloadRoute () {
      this.$router.go(0)
    },
    carregarLogo () {
      let data = new FormData()
      data.append('logotipo', this.file)
      this.uploadLogotipo(data).then(() => {
        this.reloadRoute()
      })
    },
    removerLogo () {
      if (confirm('Confirme a exclusão do logotipo desta industria.')) {
        this.removeLogotipo().then(() => {
          this.reloadRoute()
        })
      }
    }
  }
}
</script>
